import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// import axios from "axios";
export default new Vuex.Store({
  state: {
    isshowxiugai: false,//多次点击编辑按钮 循环显示隐藏以下的编辑按钮的标识符
    // isxianshiblock:false, //    模块已隐藏，将不会出现在主页显示和显示模块的  切换显示的效果的标识符
    activelistsum:'',      //当前激活的导航栏的样式
    role:'',            //用户身份
    role_name:'',     //用户名
    head:'',   //照片头像     
    newtivelist:"",      //用来确认动态卡片中是否已经取到了最新的五条数据  作判断用的标识符
    top_dynamiclist:"",      //用来确认动态卡片中是否已经取到了最新的五条数据  作判断用的标识符
    moveLeft:'',
    navlistdata:[],    //所有的菜单列表
    navdata:{},         //独一的当前菜单项
    isavtivenav:false,    //监听是否是点击导航栏菜单触发的事件
    isgoback:false,   //

    topcontainer:'',     //页头的内容
    footercontainer:'',   //页脚的内容
    // ture_false_nav:false,  //头部小屏幕的时候，向下滚动时头部组件和nav之间的事件
    home_nav_list_is_hide_on_topath:{      //导航菜单隐藏的情况下，点击首页更多，判断是否跳转
      have_value:false,
      ktzjs:false,
      yjfx:false,
      cgzs:false,
      dt:false,
      kysb:false,
      cygl:false,
      principalIntroduce:false,
      fzrjs:false
    },
    nav_more_click:'',
    dynamic_page_sum:1,   //动态的页码数
    is_dynamic_page:false,   //动态的页码数
    to_dynamicdetails_from_dynamic:false,   //动态的页码数

    home_more_click:false,     //判断是否是首页点击了查看更多的事件
    all_app_color:'',     //全局配色

    i18n_locale:'',
    EnglishUrl:'',
    // isshownavxiangqing:{
    //   isshow :false,
    //   id:''
    // }
    header_model_true:false,
    header_model_true_value:'one',
  },
  mutations: {
    // change_ture_false_click_nav(state,data){
    //   state.ture_false_nav=data;
    // },
    to_dynamicdetails_from_dynamic_change(state,data){
      // console.log(data,'to_dynamicdetails_from_dynamic');
      state.to_dynamicdetails_from_dynamic=data;
    },
    is_dynamic_page_change(state,data){
      // console.log(data,'is_dynamic_page');
      state.is_dynamic_page=data;
    },
    change_dynamic_page_sum(state,data){
      // console.log(data,'dynamic_page_sum');
      state.dynamic_page_sum=data;
    },
    change_EnglishUrl(state,data){
      state.EnglishUrl=data;
    },
    change_header_model_true_value(state,data){
      state.header_model_true_value=data;
    },
    change_header_model_true(state,data){
      state.header_model_true=data;
    },
    TWLBXQ(state,data){
      state.nav_more_click=data;
    },
    change_i18n_locale(state,lang){
      state.i18n_locale = lang;
    },
    change_all_color(state,color){
      state.all_app_color = color;
    },
    change_home_nav_list(state,data){
      state.home_nav_list_is_hide_on_topath.have_value=true;
      state.home_nav_list_is_hide_on_topath.ktzjs=data.ktzjs;
      state.home_nav_list_is_hide_on_topath.yjfx=data.yjfx;
      state.home_nav_list_is_hide_on_topath.cgzs=data.cgzs;
      state.home_nav_list_is_hide_on_topath.dt=data.dt;
      state.home_nav_list_is_hide_on_topath.kysb=data.kysb;
      state.home_nav_list_is_hide_on_topath.cygl=data.cygl;
      state.home_nav_list_is_hide_on_topath.principalIntroduce=data.principalIntroduce;
    },
    change_home_more_click(state,data){
      state.home_more_click=data;
    },
    changefootercontainer(state,data){
      state.footercontainer=data;
    },
    changetopcontainer(state,data){
      state.topcontainer=data;
    },
    isgobackclick(state){
      state.isgoback = false;
    },
    changeisshowxiangqing(state){
      state.isavtivenav =false;
    },
    changenavdata(state,data){
      state.navdata = data;
      state.isavtivenav =true;
    },
    ischangenav(state,list){
      state.navlistdata=list;
    },
    ismovenav(state,index){
      state.moveLeft=index;
    },
    isclickshow(state) {                      //多次点击编辑按钮 循环显示隐藏以下的编辑按钮
      state.isshowxiugai = !state.isshowxiugai;
    },
    isfalseclickshow(state) {                 //当已经点击了一次编辑按钮后，再点击跳转路由的话，先将组件中的编辑按钮恢复隐藏状态
      state.isshowxiugai = false;
    },
    // isclickxianshiblock(state) {               //大佬介绍中的>>    模块已隐藏，将不会出现在主页显示和显示模块的  切换显示的效果的事件 
      // state.isxianshiblock = !state.isxianshiblock;
    // },
    isclicknavactive(state,index){              //点击导航栏切换路由时，确定当前激活的样式是谁的（位置）
      state.activelistsum=index;
      state.isgoback=true;
    },
    islogintrueclick(state,data){             //登录完成后将用户名和相关通用的标识给全局保存，（用来确认要不要显示顶部的编辑按钮）
      state.role=data.role;
      state.role_name=data.role_name;
      state.head=data.head;
    },
    clickexitloginshandata(state){            //退出登录时执行的删除操作
      state.role='';
      state.role_name='';
      state.head='';
    },
    newtivedatalist(state,data){              //用来确认动态卡片中是否已经取到了最新的五条数据  作判断用
      state.newtivelist=data;
    },
    newtop_dynamiclist(state,data){              //用来确认动态卡片中是否已经取到了最新的五条数据  作判断用
      state.top_dynamiclist=data;
    }
    // increment(state, apidata) {
    //   state.panghu = apidata;
    // },

  },
})






// WEBPACK FOOTER //
// ./src/store/store.js